import {MutationTree} from "vuex";
import {PageSizeMutationTypes, PageSizeState} from "@/store/pagesize/types";

const mutations: MutationTree<PageSizeState> = {
    [PageSizeMutationTypes.setScale]: (state, scale: number) => {
        state.scale = scale;
    }
}

export default mutations;